export interface IMetaServer {
  to: number;
  from: number;
  path: string;
  total: number;
  per_page: number;
  last_page: number;
  current_page: number;
}

export interface IMeta {
  to: number;
  from: number;
  path: string;
  total: number;
  perPage: number;
  lastPage: number;
  currentPage: number;
}

export function tranformMeta(meta: IMetaServer): IMeta {
  return {
    to: meta.to,
    from: meta.from,
    path: meta.path,
    total: meta.total,
    perPage: meta.per_page,
    lastPage: meta.last_page,
    currentPage: meta.current_page,
  };
}
